import React from "react";
import uniswap from "../assets/images/svg/uniswap.svg";

const BuyDunce = () => {
  const copyToClipboard = (text) => {
    const cleanedText = text.replace(/\s+/g, " ").trim(); // Clean up extra spaces
    navigator.clipboard.writeText(cleanedText).then(
      () => {
        alert("Copied to clipboard!");
      },
      (err) => {
        console.error("Failed to copy: ", err);
      }
    );
  };

  return (
    <div
      id="buy-on-dex"
      className="2xl:max-w-[1490px] xl:max-w-[1240px] relative z-30 mx-auto lg:px-5 md:px-8 px-5 container 2xl:py-[100px] lg:py-16 md:py-12 sm:py-10 py-9 2xl:mt-32 xl:mt-24 lg:mt-20 mt-16"
    >
      <div className="flex gap-[30px]">
        <div className="bg-pink-bg w-full xl:max-w-[1166px] mx-auto lg:px-0 px-10 lg:py-24 md:py-20 sm:py-16 py-12 md:border-4 border-2 border-dark-purple md:shadow-lgPurpleShadow shadow-smPurpleShadow md:rounded-28 sm:rounded-18 rounded-2xl">
          <p className="text-center text-dark-purple leading-100 2xl:text-6xl md:text-5xl text-custom-5xl">
            Buy on dex
          </p>
          <p className="font-roboto font-medium lg:text-xl md:text-lg text-base leading-150 max-w-[365px] mx-auto text-center text-dark-purple">
            Use your web3 wallet and connect to the dex of your choice to buy
            $DUNCE.
          </p>
          <div className="lg:pt-[50px] md:pt-12 sm:pt-10 py-8 sm:flex-row flex-col flex max-w-[714px] justify-center md:gap-[30px] gap-6 mx-auto">
            <a
              href="https://app.uniswap.org/"
              target="_blank"
              className="flex gap-[15px] items-center py-[15px] px-[38px] hover:translate-y-2 hover:shadow-none transition-all duration-300 ease-in-out bg-dark-purple rounded-18 border-2 border-pink-bg sm:w-[324px] w-[250px] mx-auto h-[78px] justify-center shadow-roadmapArrowShadow"
            >
              <img src={uniswap} alt="uniswap-icon" />
              <span className="text-white sm:text-custom-4xl text-2xl !leading-100 [text-shadow:2px_2px_0px_#000000] translate-y-[3px]">
                Uniswap
              </span>
            </a>
          </div>
        </div>
      </div>
      <div id="buy-on-cex" className="flex gap-[30px] mt-20">
        <div className="bg-pink-bg w-full xl:max-w-[1166px] mx-auto lg:px-0 px-10 lg:py-24 md:py-20 sm:py-16 py-12 md:border-4 border-2 border-dark-purple md:shadow-lgPurpleShadow shadow-smPurpleShadow md:rounded-28 sm:rounded-18 rounded-2xl">
          <p className="text-center text-dark-purple leading-100 2xl:text-6xl md:text-5xl text-custom-5xl">
            Buy on cex
          </p>
          <p className="font-roboto font-medium lg:text-xl md:text-lg text-base leading-150 text-center text-dark-purple">
            $DUNCE will be listed on the most popular Centralized Exchanges.
          </p>
          <div className="pt-10">
            <button className="py-[15px] px-[38px] hover:translate-y-2 transition-all duration-300 ease-in-out bg-light-purple rounded-18 border-2 border-dark-purple sm:w-[324px] w-[250px] mx-auto h-[78px] flex items-center justify-center text-white sm:text-custom-4xl text-2xl leading-100 [text-shadow:2px_2px_0px_#000000]">
              COMING SOON
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuyDunce;
